import ApiService from '../../services/api.service';
import OwnerModel from '../owner/owner-model';

export default class MessageModel {
    id: number;
    name: string;
    description: string;
    status: string;
    type: string;
    typeCaption: string;
    owner: any;
    ownerCaption: string;
    sent: string;
    from: string;
    to: string;
    cc: string;
    bcc: string;
    replyto: string;
    subject: string;
    text: string;
    html: string;
    attachment: any;
    attachmentId: number;
    attachmentUrl: string;
    astemplate: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.type = datarow.type || 'email';
        this.typeCaption = MessageModel.optionType.filter((d: any) => d.name === this.type)?.[0]?.caption || 'Email';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name; 
        this.sent = datarow.sent || 'yes';
        this.from = datarow.from;
        this.to = datarow.to;
        this.cc = datarow.cc;
        this.bcc = datarow.bcc;
        this.replyto = datarow.replyto;
        this.subject = datarow.subject;
        this.text = datarow.text;
        this.html = datarow.html;
        this.attachment = datarow.attachment?.data?.[0];
        this.attachmentId = this.attachment?.id;
        this.attachmentUrl = this.attachment?.attributes.mime?.includes('image')? ApiService.svrUrl+this.attachment.attributes.url : this.attachment?.attributes.name;
        this.astemplate = datarow.astemplate;
    } 

    public static endPoint: string = 'messages' 
    public static endPointMedia: string = 'api::message.message';
    public static endPointFilterList = (astemplate?: string) => {
        const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' + owner + '&filters[astemplate]=' + (astemplate||'no'));
    } 
    public static url: string = '/message';
    public static caption: string = 'Message';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        type: 'email',
        typeCaption: 'Email',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),   
        sent: 'yes',
        from: '',
        to: '',
        cc: '',
        bcc: '',
        replyto: '',
        subject: '',
        text: '', 
        html: '', 
        attachment: null,
        attachmentId: 0,
        attachmentUrl: '',
        astemplate: 'no',
  
        }
    }
    
    public static validations = [
        { name: 'to', required: true, minLength: 3 },
        { name: 'subject', required: true, minLength: 3 },
        { name: 'text', required: true, minLength: 3 },
    ]

    public static columns = [
        { name: 'to', caption: 'Send To' },
        { name: 'subject', caption: 'Subject' },
        { name: 'typeCaption', caption: 'Type' },
    ]

    public static columnPicklist = [
        { name: 'to', caption: 'To' },
        { name: 'subject', caption: 'Subject' },
        { name: 'typeCaption', caption: 'Type' },
    ]

    public static columnTemplate = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: 'Status', type: 'state', default: 'active' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'email', caption: 'Email' },
        { name: 'sms', caption: 'SMS' },
        { name: 'whatsapp', caption: 'WhatsApp' },
    ]
}